import { getMartData } from "api/ApiCalls"
import { applyFetcherOptions } from "helpers/martHelpers"
import type { IServerSideGetRowsRequest } from "@ag-grid-community/core"
import type { MartFetcherOptions } from "types/ApiTypes"

// Deprecated

type CryptoScreenerData = Record<string, string | number>

const CRYPTO_SCREENER_DATASET = "crypto_screener"

const DEFAULT_SSRM_REQUEST: IServerSideGetRowsRequest = {
  startRow: 0,
  endRow: 100,
  rowGroupCols: [],
  valueCols: [],
  pivotCols: [],
  pivotMode: false,
  groupKeys: [],
  filterModel: {},
  sortModel: [{ sort: "desc", colId: "fees_30d_sum" }],
}

export async function getCryptoScreenerData<T = Array<CryptoScreenerData>>(
  body: IServerSideGetRowsRequest = DEFAULT_SSRM_REQUEST,
  opts?: MartFetcherOptions
) {
  if (opts) {
    applyFetcherOptions(body, opts)
  }
  const martData = await getMartData<T>(CRYPTO_SCREENER_DATASET, body)

  return martData.data
}
